export default {
	lang: 'it',
	roof: 'Tetto',
	facade: 'Facciata',
	searchForAddress: 'Inserire l\'indirizzo qui...',
	address: 'Indirizzo',
	map: 'Mappa',
	or: 'o',
	clickOn: 'Clicca su un tetto sulla',
	selectedAddress: 'Indirizzo selezionato',
	notYetLocalised: 'Non ancora localizzato',
	indicateLocation: 'Indica la tua posizione',
	whatRoofType: 'Che tipo di tetto avete?',
	unselected: 'Scegliere il tipo di tetto',
	tile: 'Tegola',
	tin: 'Lamiera',
	other: 'Altro / Sconosciuto',
	corrugatedEternit: 'Eternit ondulato',
	slateEternit: 'Eternit ardesia',
	gravel: 'Tetto piano in ghiaia',
	substrate: 'Tetto piano con substrato',
	wallbox: 'Wallbox',
	wallboxDescription: 'L\'installazione di una wallbox è un investimento orientato al futuro. Grazie all\'interazione intelligente con l\'impianto solare, la vostra flotta può essere alimentata con elettricità conveniente oggi o in futuro.',
	backupPower: 'Alimentazione di emergenza',
	backupPowerDescription: 'Anche in caso di interruzione di corrente, l\'impianto solare continua ad alimentare gli apparecchi più importanti. In genere si tratta di dispositivi come congelatori, illuminazione, telefono e Internet.',
	additionalOfferings: 'Offerte aggiuntive',
	yourLocation: 'Posizione del tetto e contatto',
	mr: 'Sig.',
	mrs: 'Sig.ra',
	firstName: 'Nome',
	surname: 'Cognome',
	email: 'E-mail',
	phone: 'Telefono',
	postalCode: 'Codice postale',
	city: 'Città',
	addressCap: 'Indirizzo',
	comments: 'Osservazioni',
	addressSameAsAbove: 'L\'indirizzo è lo stesso di sopra',
	state: 'Cantone',
	street: 'Via',
	submit: 'Inviare',
	invalidEmail: 'Indirizzo e-mail non valido',
	invalidPhone: 'Numero di telefono non valido',
	invalidCaptcha: 'Il token CAPTCHA non è valido',
	submissionComplete: 'Richiesta inviata',
	sendingData: 'Invio delle informazioni...',
	submissionError: 'Si è verificato un errore!',
	apiErrorMessage: 'Servizio non disponibile: la richiesta non può essere elaborata al momento.',
	apiInvalidCaptchaMessage: 'Il token CAPTCHA non è valido o è scaduto. Aggiornare la pagina e riprovare.',
	mandatoryField: 'Il campo non può essere vuoto',
	enterCustom: 'Inserire i dati personalizzati',
	customRoof: 'Torna alla mappa',
	mapMode: 'Inserimento manuale',
	length: 'Lunghezza',
	width: 'Larghezza',
	unit: 'm',
	area: 'Superficie',
	slope: 'Inclinazione',
	data: 'Dati',
	pleaseEnter: 'Inserire l\'indirizzo del tetto o aggiungere i dati personalizzati del tetto',
	selectRoofType: 'Selezionare il tipo di tetto',
	multipleRoofLabel: 'Più tetti',
	clearRoofSelectionLabel: 'Ripristina',
	orientation: 'Orientamento del tetto',
	north: 'N',
	northeast: 'NE',
	east: 'E',
	southeast: 'SE',
	south: 'S',
	southwest: 'SO',
	west: 'O',
	northwest: 'NO',
	roof1: 'Tetto 1',
	electricityProductionPerYear: 'Produzione di elettricità all\'anno',
	electricityProductionPerYearUnit: 'kWh',
	amountOfHouseholds: 'Numero di famiglie',
	financialReturnIn30years: 'Rendimento in 30 anni',
	financialReturnIn30yearsUnit: 'CHF',
	deleteTab: 'Elimina tetto',
	undo: 'Annulla',
	removed: 'rimosso',
	welcomeMessage: 'La vostra offerta solare personale in tre minuti',
	cookieConsentBanner1: 'Il nostro sito utilizza cookie di tracciamento per effettuare analisi dettagliate e ottimizzare le misure di marketing.',
	cookieConsentBanner2: 'In questo modo possiamo migliorare continuamente la vostra esperienza utente.',
	acceptButtonText: 'Accetta',
	declineButtonText: 'Rifiuta',
	title: "Calcolatore solare di Elektrobedarf Troller",
	description: "Elettricità dalla luce solare — selezionate il tetto, calcolate il rendimento e richiedete un'offerta.",
	publisher: "Editore e responsabile del contenuto: Patrick Troller, direttore generale",
	development: "Sviluppo:",
	t2consultAddress: "Am Heidberg 14, 24211 Preetz - Germania",
	additionalSuccessMessage: "Grazie! Il vostro consulente solare personale sta preparando la vostra offerta individuale.",
	consultantHint: "ⓘ Ogni offerta viene verificata personalmente da un esperto solare e adattata al vostro tetto. I vostri dati vengono trattati in modo confidenziale e non vengono trasmessi a terzi.",
	nextStep: "Avanti",
	nextToRoofType: "Avanti al tipo di tetto",
	directContact: "Contattaci",
	nextToTeaser: "Avanti alla panoramica",
	nextToOfferings: "Avanti alle offerte",
	nextToContact: "Avanti al modulo di contatto",
	backToAddress: "Torna all'indirizzo",
	backToRoofType: "Torna al tipo di tetto",
	backToTeaser: "Torna alla panoramica",
	backToOfferings: "Torna alle offerte",
	teaserHeading: "Il vostro potenziale solare personale",
	teaserSubheading: "Sulla base di questi dati, prepareremo la vostra offerta individuale.",
	offeringsHint: "Queste opzioni verranno discusse in dettaglio durante la vostra consulenza personale.",
	solarSuitability: "Idoneità solare",
	solarExcellent: "Eccellente",
	solarVeryGood: "Molto buono",
	solarGood: "Buono",
	solarMedium: "Medio",
	solarLow: "Scarso",
	addAnotherRoof: '+ Aggiungi un altro tetto',
	enterAddressHint: 'Inserite il vostro indirizzo o selezionate il vostro tetto sulla mappa',
	doubleClickHint: 'Doppio clic su un edificio = selezionare l\'intero tetto',
	doubleTapHint: 'Doppio tocco su un edificio = selezionare l\'intero tetto',
	maxRoofsReached: 'Massimo 3 tetti raggiunto. Altri tetti? Indicatelo nel campo osservazioni – un esperto solare si occuperà del vostro progetto.',
}
